module.exports = __webpack_public_path__ + "img/EditorialDerVergesseneUrsprungThumbnail-768.c8329459.jpg";